module.exports = __webpack_public_path__ + "img/zerobit.ca6192dc.png";